var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-tags-input',{staticClass:"visualize-ti-input",style:(_vm.styledBgColor),attrs:{"tags":_vm.styledTags,"placeholder":"","disabled":true},scopedSlots:_vm._u([{key:"tag-actions",fn:function(props){return _c('div',{})}}]),model:{value:(_vm.tag),callback:function ($$v) {_vm.tag=$$v},expression:"tag"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }